import Alert from './Alert.vue';
import Indicator from './Indicator.vue';

export default [
  Alert,
  Indicator,
];
